import { render, staticRenderFns } from "./PurchaseOrdersAutocomplete.vue?vue&type=template&id=c126f9a0&scoped=true"
import script from "./PurchaseOrdersAutocomplete.vue?vue&type=script&lang=js"
export * from "./PurchaseOrdersAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c126f9a0",
  null
  
)

export default component.exports